'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable max-len */

var OffensiveLanguage = function (_BcReactComponent) {
  _inherits(OffensiveLanguage, _BcReactComponent);

  function OffensiveLanguage() {
    _classCallCheck(this, OffensiveLanguage);

    return _possibleConstructorReturn(this, (OffensiveLanguage.__proto__ || Object.getPrototypeOf(OffensiveLanguage)).apply(this, arguments));
  }

  _createClass(OffensiveLanguage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-offensive-language', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
        _react2.default.createElement('path', { className: 'path1', d: 'M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM9 10h-2v-2h2v2zM9 6h-2v-4h2v4z' })
      );
    }
  }]);

  return OffensiveLanguage;
}(_baseBcReactComponent2.default);

exports.default = OffensiveLanguage;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/OffensiveLanguage/OffensiveLanguage.js
// module id = 123
// module chunks = 0 1 2 3 4 5 6 7 8 9